import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  }, {
    path: '/getTmpl.htm',
    name: 'getTmpl',
    component: (resolve) => require(['@/views/uheart/getTmpl'], resolve)
  }, {
    path: '/welcome.htm',
    name: 'welcome',
    component: (resolve) => require(['@/views/uheart/welcome'], resolve)
  }, {
    path: '/register.htm',
    name: 'register',
    component: (resolve) => require(['@/views/uheart/register'], resolve)
  }, 
  {
    path: '/registerWorkshop.htm',
    name: 'registerWorkshop',
    component: (resolve) => require(['@/views/uheart/registerWorkshop'], resolve)
  }, 
  {
    path: '/login.htm',
    pid: '0',
    name: 'Login',
    depth: '0',
    component: (resolve) => require(['@/views/login'], resolve)
  }, {
    path: '/forgetPwd.htm',
    name: 'forget',
    component: (resolve) => require(['@/views/system/forgetPwd'], resolve)
  }, {
    path: '/forgetResetPwd.htm',
    name: 'forgetResetPwd',
    component: (resolve) => require(['@/views/system/forgetResetPwd'], resolve)
  }, {
    path: '',
    component: Layout,
    redirect: 'index.htm',
    children: [
      {
        path: 'index.htm',
        component: (resolve) => require(['@/views/index'], resolve),
        name: "home",
        meta: { title: localStorage.getItem('lang-home') || 'Home', icon: 'dashboard', noCache: true, affix: true }
      }
    ]
  }, {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'userInfo.htm',
        component: (resolve) => require(['@/views/system/userInfo'], resolve),
        name: 'Profile',
        meta: { title: localStorage.getItem('lang-person') || 'Personal Center', icon: 'user' }
      }
    ]
  }, {
    path: '/sso.htm',
    name: 'SSO',
    component: (resolve) => require(['@/views/sso'], resolve)
  },
  {
	path: '/stpurl.htm',
	name: 'stpurl',
	component: (resolve) => require(['@/views/stpurl'], resolve)
  }]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js